module.exports = new __parcel__URL__("mute.df33baa4.svg").toString();